import React from "react";
import Container from "react-bootstrap/esm/Container";

function Footer() {
  return (
    <footer className="footer">
      <Container className="footer-container">
        <div className="footer-text">
          <h3>synaesthetic media lab</h3>
          {/*<a href="mailto:info@synlab.ca" className="footer-text-p-a">
            info@synlab.ca
          </a>*/}
          <p className="footer-text-p-a">
            Suite # N103, 483 Bay Street, Toronto, Ontario, Canada M5G 2E1
          </p>
        </div>

        <div className="footer-logos">
          <img
            src="./logos/TCS_logo.png"
            alt="The Creative School Logo"
            className="footer-logo"
          />
          <img
            src="./logos/TMU_logo.png"
            alt="TMU Logo"
            className="footer-logo"
          />
        </div>
        {<p className="copyright">
          ©&nbsp;{new Date().getFullYear()} Synlab All Rights
          Reserved.
        </p>}
      </Container>
    </footer>
  );
}

export default Footer;
